import { render } from "./RingRing.vue?vue&type=template&id=4d673341&scoped=true"
import script from "./RingRing.vue?vue&type=script&lang=js"
export * from "./RingRing.vue?vue&type=script&lang=js"

import "./RingRing.vue?vue&type=style&index=0&id=4d673341&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d673341"]])

export default __exports__